/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, NavListItem } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import { branding } from 'stripes-config';
import css from './styles.css';
import { CurrentAppGroup } from '../../MainNav/CurrentApp';
import ProfileDropdown from '../../MainNav/ProfileDropdown';
import NavDivider from '../../MainNav/NavDivider';
import UserLocalesMenu from '../LocaleSwitcher/UserLocalesMenu';
import AppList from '../../MainNav/AppList';
// import logo from '../../../../icons/imamu_logo.png';
// import logo from '../../../../icons/kware.png';
import SettingsButton from '../SettingsButton/SettingsButton';
import HelpeButton from '../HelpeButton/HelpeButton';
import SmartHelpButton from '../SmartHelpButton/SmartHelpButton';
import FullScreenButton from '../FullScreenButton/FullScreenButton';

function LibraryNav({
  selectedApp,
  settingsApps,
  stripes,
  logout,
  apps,
  history,
}) {
  const [isFullScreen, setIsFullScreen] = useState(false);
  /** kware start edit - Track font size changes to force AppList re-render */
  const [fontSizeKey, setFontSizeKey] = useState(0);
  /** kware end edit */
  const intl = useIntl();
  const helpUrl = stripes.config.helpUrl ?? 'https://docs.folio.org';

  /** kware start edit - Listen to font size changes and update key to force re-render */
  React.useEffect(() => {
    const handleFontSizeChange = () => {
      setFontSizeKey(prev => prev + 1);
    };
    window.addEventListener('fontSizeChanged', handleFontSizeChange);
    return () => window.removeEventListener('fontSizeChanged', handleFontSizeChange);
  }, []);
  /** kware end edit */

  const navigateByUrl = (link) => {
    history.push(link.route);
  };

  const onHome = () => {
    navigateByUrl({ route: '/' });
  };

  const headerStyle = {
    '--main-nav-background-color':
      branding.theme?.mainNavBackgroundColor || '#3992a4',
  };

  return (
    <header className={css.headerRoot} style={headerStyle}>
      <nav className={css.navRoot}>
        <div className={css.startSection}>
          <Button
            buttonStyle="slim"
            onClick={onHome}
            onMouseDown={(e) => e.preventDefault()}
            marginBottom0
          >
            <img
              width={branding.logo.css.width}
              height={branding.logo.css.height}
              src={branding.logo.src}
              alt="logo"
            />
          </Button>
        </div>
        <div className={css.appList}>
          <div className={css.selectedApp}>
            <CurrentAppGroup
              selectedApp={selectedApp}
              config={stripes.config}
            />
          </div>
          <AppList key={`${intl.locale}-${fontSizeKey}`} apps={apps} selectedApp={selectedApp} />
        </div>
        <div className={css.endSection}>
          <ProfileDropdown onLogout={logout} stripes={stripes} />
          <NavDivider md="hide" />
          <UserLocalesMenu stripes={stripes} />
          <NavDivider md="hide" />
          <SettingsButton
            settingsApps={settingsApps.map((app) =>
              app.module.replace('@folio/', ''),
            )}
            navigateByUrl={navigateByUrl}
            selectedAppName={selectedApp?.name}
            hasPerm={stripes.hasPerm(`settings.${selectedApp?.name}.enabled`)}
          />
          <NavDivider md="hide" />
          <SmartHelpButton setIsFullScreen={setIsFullScreen} />
          <NavDivider md="hide" />
          <HelpeButton helpUrl={helpUrl} setIsFullScreen={setIsFullScreen} />
          <NavDivider md="hide" />
          <FullScreenButton
            isFullScreen={isFullScreen}
            setIsFullScreen={setIsFullScreen}
          />
        </div>
      </nav>
    </header>
  );
}

const propTypes = {
  selectedApp: PropTypes.shape({
    displayName: PropTypes.string,
    home: PropTypes.string,
    iconData: PropTypes.object, // Only used by "Settings" since it's not a standalone app yet
    name: PropTypes.string,
    route: PropTypes.string,
  }),
  stripes: PropTypes.shape({
    config: PropTypes.shape({
      showPerms: PropTypes.bool,
      showHomeLink: PropTypes.bool,
      helpUrl: PropTypes.string,
    }),
    hasPerm: PropTypes.func,
    okapi: PropTypes.object,
    user: PropTypes.shape({
      user: PropTypes.object,
      perms: PropTypes.object,
    }),
  }).isRequired,
  logout: PropTypes.func,
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      description: PropTypes.string,
      id: PropTypes.string,
      href: PropTypes.string,
      active: PropTypes.bool,
      name: PropTypes.string,
      icon: PropTypes.string,
      iconData: PropTypes.object, // Only need because "Settings" isn't a standalone app yet
    }),
  ),
  settingsApps: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

LibraryNav.propTypes = propTypes;

export default LibraryNav;
